//*TODO: Add all missing events here by checking on RN-App [FSS-3205]
//*TODO: Batch events as per their use cases and then sort them alphabetically [FSS-3205]

enum CustomEventTypes {
  ADD_ADDRESS = 'AddAddress',
  ADD_NEW_ADDRESS_1 = 'AddressAddNewClicked',
  ADD_NEW_ADDRESS_2 = 'AddNewAddressClick',
  ADD_ONE_ITEM_TO_CART = 'PlusIconClick',
  ADD_TO_CART = 'AddToCartClick',
  ADDRESS_DELETE = 'AddressDelete',
  ADDRESS_EDIT = 'AddressEdit',
  ADDRESS_MORE = 'AddressThreeDots',
  APP_BACK_BUTTON = 'BackIconClick',
  ASK_EXPERT = 'AskExpertsClick',
  BLOG_PAGE_VIEW = 'BlogDetailsPageView',
  BOTTOM_NAV_BAR_CLICKED = 'BottomNavBarClicked',
  BUY_NOW = 'BuyNowClick',
  CALL_CUSTOMER_CARE = 'CallCustomerCare',
  CANCEL_ORDER = 'OrderCancelled',
  CART_ADDRESS_PROMPT_CANCEL = 'CartAddressPromptCancel',
  CART_ADDRESS_PROMPT_PROCEED = 'CartAddressPromptProceed',
  CART_RESET = 'CartReset',
  CHANGE_ADDRESS = 'ChangeAddress',
  CHECK_COUPON_OFFERS = 'CheckOffersCoupons',
  COMMUNITY_POST_SHARED = 'CommunityPostShared',
  CONFIRM_ADDRESS = 'ConfirmAddressClick',
  CONSULT_AGRI_DOCTOR_CLICK = 'ConsultAgriDoctorClick',
  CROP_ICON = 'CropIconClick',
  CROSS_ICON = 'CrossIconClick',
  DEHAAT_FEED_CLICK = 'DeHaatFeedClick',
  DEHAAT_FEED_SHARED = 'DeHaatFeedShared',
  DELETE_PRODUCT_FROM_CART = 'RemoveProductClick',
  FARM_REPORT_FEEDBACK_INTENT = 'FarmReportFeedbackIntent',
  FARM_REPORT_LEFT_TOOGLE = 'FarmHealthReportLeftToggle',
  FARM_REPORT_MEANING = 'FarmHealthReportMeaning',
  FARM_REPORT_RIGHT_TOOGLE = 'FarmHealthReportRightToggle',
  HAMBRUGER_MENU_SELECTED = 'HamburgerMenuOptionSelected',
  HAMBURGER_MENU_CLICK = 'HamburgerMenuClicked',
  HOME_BANNER = 'HomeBannerClicked',
  HOME_ICON_CLICKS = 'HomeIconClicks',
  HOME_PAGE_SCROLLED_TO_500PX = 'HomePageScrolledBy500px',
  HOME_PAGE_TAB = 'HomePageSection',
  INITIATE_CANCEL_ORDER = 'CancelOrderIntent',
  INITIATE_DISEASE_COMMUNICATION = 'ClickPhotoforDiseaseIntent',
  INSURANCE_CATEGORY = 'InsuranceCategoryClick',
  LANGUAGE_UPDATE = 'FarmerLanguageUpdate',
  LIKE_COMMUNITY_POST = 'CommunityPostLike',
  LIKE_DEHAAT_FEED = 'DeHaatFeedLike',
  LOCATION_PERMISSION_DENIED = 'LocationPermissionDenied',
  LOCATION_PERMISSION_GRANTED = 'LocationPermissionGranted',
  LOGIN_TRIGGERED = 'LoginTriggered',
  NEW_ADDRESS_SAVED = 'AddressAddNewSaved',
  NON_HYPERLOCAL_PLACE_ORDER_ENQUIRY = 'NonHyperlocalPlaceOrderEnquiry',
  NOTIFICATION_HARD_ASK_SHOWN = 'NotificationHardAskShown',
  NOTIFICATION_PERMISSION_DENIED = 'NotificationPermissionDenied',
  NOTIFICATION_PERMISSION_GRANTED = 'NotificationPermissionGranted',
  NOTIFICATION_PROMPT_CLOSED = 'NotificationPromptClosed',
  NOTIFICATION_TURN_ON_CLICKED = 'NotificationTurnOnClicked',
  ONBOARDING_LANGUAGE_SELECTION = 'LanguageSelectedOnboarding',
  OPEN_PRODUCT_LIST = 'OpenProductList',
  ORDER_CREATED = 'OrderCreated',
  ORDER_DETAILS_VIEW = 'OrderViewDetails',
  ORDER_HELP = 'NeedHelpClick',
  OTP_TRIGGERED = 'OTPTriggered',
  PRODUCT_AVAILABLE = 'ProductAvailable',
  PRODUCT_OUT_OF_STOCK = 'ProductOutOfStock',
  RATING_SUBMITTED = 'RatingSubmitted',
  READ_MORE = 'ReadMoreClick',
  REMOVE_INSURANCE_PROMPT_CANCEL = 'RemoveInsurancePromptCancel',
  REMOVE_INSURANCE_PROMPT_PROCEED = 'RemoveInsurancePromptProceed',
  REMOVE_ONE_ITEM_FROM_CART = 'MinusIconClick',
  SCROLLED_TO_500PX = 'Scrolledby500px',
  SEARCH_BY_VOICE = 'SearchByVoice',
  SEARCH_RESET = 'SearchCrossIcon',
  SELECT_ADDRESS = 'SelectAddress',
  SHOW_PRODUCT_INSURANCE_LIST = 'ShowProductInsuranceList',
  SHOWING_CART_ADDRESS_PROMPT = 'ShowCartAddressPrompt',
  TERM_SHEET_DOWNLOADED = 'TermSheetDownload',
  TERM_SHEET_PAGE_OPENED = 'VisitedTermSheets',
  TextToSpeechPaused = 'TextToSpeechPaused',
  TextToSpeechPlayed = 'TextToSpeechPlayed',
  TextToSpeechResumed = 'TextToSpeechResumed',
  VENDOR_CALL_SHOP = 'CallShopButton',
  VENDOR_CARD_RIGHT_SCROLL = 'RightScroll',
  VENDOR_DIRECTION = 'NavigateButton',
  VIEW_CROP_PROBLEM = 'CropProblemViewed',
  WHATSAPP_SHARE = 'WhatsappShare',
  PRODUCT_EDIT_PRICE_CLICKED = 'HyperlocalPriceEditCTAClicked',
  HYP_PRICED_EDITED = 'HyperlocalProductPriceEdited',
  VARIANT_SELECTION = 'VariantSelection',
  KNOW_MORE_CLICK = 'KnowMoreClick',
  ADD_TO_CART_INTENT = 'AddtoCartIntent',
  TOGGLE_DOWN_CLICK = 'ToggleDownClick',
  VIDEO_PLAY_CLICK = 'VideoPlayClick',
  SHORTS_PLAY_CLICK = 'ShortsPlayClick',
  GROWTH_USER_MOBILE_NUMBER = 'GrowthUserMobileNumber',
  GROWTH_USER_DETAILS = 'GrowthUserDetails',
  GROWTH_ORDER_DETAILS = 'GrowthOrderDetails',
  ADD_TO_CART_STARTER = 'AddToCart',
  INITIATE_CHECKOUT = 'InitiateCheckout',
  GROWTH_PURCHASE = 'GrowthPurchase',
  GROWTH_OTP_SENT = 'GrowthOTPSent',
  MANDI_PRICE_DETAILS_CLICK = 'MandiPriceDetailsIntent',
  MANDI_WEATHER_ICON_CLICK = 'WeatherIconClick',
  MANDI_LIST_VIEW_MORE_CLICK = 'MandiHomeViewMoreClick',
  MANDI_SERVICES_CLICK = 'MandiRelatedServicesClick',
  MANDI_SUBMIT_RECIEPT_FORM_FIELDS = 'MandiServiceForm',
  MANDI_CROP_PHOTO_SUBMISSION_INTENT = 'MandiFasalPhotoSubmissionIntent',
  MANDI_CROP_PHOTO_ADDED = 'MandiFasalPhotoAdded',
  MANDI_RECIEPT_PHOTO_SUBMISSION_INTENT = 'MandiReceiptPhotoSubmissionIntent',
  MANDI_RECIEPT_PHOTO_ADDED = 'MandiReceiptPhotoAdded',
  MANDI_FORM_SUBMISSION = 'MandiServiceFormSubmission',
  SHRI_CARD_ACTIVATE_INTENT = 'ShriCardActivateIntent',
  SHRI_CARD_ACTIVATE_LOGIN_INTENT = 'ShriCardActivateLoginIntent',
  SHRI_CARD_APPLY_INTENT = 'ShriCardApplyIntent',
  SHRI_CARD_APPLY_LOGIN_INTENT = 'ShriCardApplyLoginIntent',
  APPLY_SHRI_CARD = 'ApplyShriCard',
  VALIDATE_SHRI_CARD_NUMBER = 'ValidateShriCardNumber',
  FETCH_LOCATION_INTENT = 'FetchLocationIntent',
  ADD_AND_SAVE_ADDRESS_INTENT = 'AddandSaveAddressIntent',
  ACTIVATE_SHRI_CARD_PROGRAM = 'ActivateShriCardProgramScreen',
  PRODUCT_BUY_INTENT_SHRI_CARD = 'ProductBuyIntentShriCard',
  SHRI_CARD_NOT_AVAILABLE = 'ShriCardNotAvailableAtLocation',
  VARIANT_SELECTION_FOR_CART = 'VariantSelectionForCart',
  OPEN_PRODUCT_DETAIL = 'OpenProductDetail',
  PRODUCT_DETAILS_VARIANT_SELECT = 'VariantSelected',
  PRODUCT_FILTER_CHIP_REMOVED = 'ProductFilterChipRemoved',
  PRODUCT_FILTER_CLICK = 'ProductFilterClick',
  ORDER_ISSUE_SUBCATEGORY_SELECT = 'RaiseIssueSubCategorySelection',
  ORDER_ISSUE_RAISE_ISSUE_CLICK = 'RaiseIssueClick',
  ORDER_ISSUE_IMAGE_SELECTION = 'RaiseIssueImageSelection',
  ORDER_DETAILS_ISSUES_LIST_ITEM_CLICK = 'CheckIssue',
  ORDER_ISSUE_CHECKBOX_CLICK = 'CheckboxClick',
  ORDER_ISSUE_PLUS_MINUS_CLICK = 'GrievancePlusOrMinusClick',
  ORDER_ISSUE_STEP1_CLICK = 'RaiseIssueStep1',
  PRODUCT_DETAILS_DELIVERY_ICON_CLICK = 'DeliveryIconClicks',
  THREE_DOTS_CLICK = 'ThreeDotsClick',
  ORDER_DETAILS_GET_STATUS_CLICK = 'GetOrderStatus',
  ORDER_DETAILS_NEED_HELP_CLICK = 'NeedHelpInOrderClick',
  ORDER_DETAILS_DOWNLOAD_INVOICE_CLICK = 'ViewOrDownloadInvoiceIntent',
  ORDER_DETAILS_RETURN_INTENT = 'OrderReturnIntent',
  ORDER_RETURN_REASON_SELECT_INTENT = 'OrderReturnReasonSelectIntent',
  ORDER_RETURN_REASON_SELECT = 'OrderReturnReasonSelection',
  ORDER_RETURN_IMAGE_SELECTION = 'ReturnFlowImageSelection',
  ORDER_RETURN_CONFIRMATION_CLICK = 'ReturnOrderConfirmation',
  DELETE_USER_ACCOUNT = 'DeleteUserAccount',
  SATELLITE_SEND_SELFIE_BUTTON_CLICKED = 'Satellite Send Selfie Button Clicked',
  SATELLITE_ADD_FARM_REACHED = 'Satellite Add Farm Reached',
  SATELLITE_CLICK_SELFIE_LATER = 'Satellite Click Selfie Later',
  SATELLITE_SELFIE_CLICKED = 'Satellite Selfie Clicked',
  SATELLITE_FARM_NAME_ADDED = 'Satellite Farm Name Entered',
  SATELLITE_CROP_ADDED = 'Crop Selected',
  SATELLITE_SHARE_CLICKED = 'Satellite Share Clicked',
  SATELLITE_GO_TO_HOME_CLICKED = 'Satellite Go To Home Clicked',
  SATELLITE_FARM_FEEDBACK_ADDED = 'Feedback Added',
  SATELLITE_CHANGE_CROP = 'Satellite Change Crop Intent',
  FARM_REPORT_DELAY_INFO_CHECK = 'FarmReportDelayInformationCheck',
  SATELLITE_REPORT_VIEW = 'Satellite Report View',
  SATELLITE_DELETE_CROP = 'Satellite Farm Deleted',
  SATELLITE_ADD_FARM_INTEREST = 'Satellite Add Farm Interest',
  SERVICE_LANDING_PAGE_VISITED = 'Service Landing Page Visited',
  SERVICE_BOOKING_INITIATED = 'Service Booking Initiated',
  SERVICE_PROVIDER_CHANGED = 'Service Provider Changed',
  SERVICE_PACKAGE_SELECTED = 'Service Package Selected',
  SERVICE_MANDATORY_FIELD_ADDED = 'Service Mandatory Field Added',
  SERVICE_MANDATORY_FIELDS_SUBMITTED = 'Service Mandatory Fields Submitted',
  SERVICE_ADDRESS_ADDED = 'Service Address Added',
  SERVICE_USER_CLICKS_TO_BOOK_NOW = 'Service User Clicks to Book Now',
  SERVICE_USER_SELECTS_PAYMENT_METHOD = 'Service User Selects Payment Method',
  USER_LANDED_ON_PRODUCT_DETAIL_PAGE = 'UserLandedOnProductDetailPage',
  USER_LANDED_ON_PRODUCT_LISTING_PAGE = 'UserLandedOnProductListingPage',
  USER_APPLIED_FILTER_ON_PRODUCT_LISTING_PAGE = 'UserAppliedFilterOnProductListingPage',
  PRODUCT_SEARCH_INITIATED = 'ProductSearchInitiated',
  USER_LANDED_ON_COMMERCE_PLATFORM_HOME = 'UserLandedOnCommercePlatform',
  DESIRED_QUANTITY_MISMATCH = 'DesiredQuantityMismatch',
  PLACE_CTA_ORDER_CLICKED = 'PlaceCTAOrderClicked',
  PAYMENT_MODE_SELECTED = 'PaymentModeSelected',
  USER_LANDED_ON_SHOP_BY_CROP = 'UserLandedOnShopByCrop',
  USER_LANDED_ON_SHOP_BY_BRAND = 'UserLandedOnShopByBrand',
  ASK_HELP_USER_LANDED = 'AskHelpUserLanded',
  ASK_HELP_USER_LANDED_ON_DISEASE_QUESTION_PAGE = 'AskHelpUserLandedOnDiseaseQuestionPage',
  ASK_HELP_TAKE_PHOTO_CTA_CLICKED = 'AskHelpTakePhotoCTAClicked',
  ASK_HELP_IMAGE_UPLOADED = 'AskHelpImageUploaded',
  ASK_HELP_CROP_SELECTION_CONFIRMED = 'AskHelpCropSelectionConfirmed',
  ASK_HELP_QUESTION_SAVED = 'AskHelpQuestionSaved',
  ASK_HELP_SOWING_MONTH_SELECTED = 'AskHelpSowingMonthSelected',
  ASK_HELP_SOWING_WEEK_SELECTED = 'AskHelpSowingWeekSelected',
  ASK_HELP_CROP_MEDICINE_OPTION_SELECTED = 'AskHelpCropMedicineOptionSelected',
  ASK_HELP_QUESTION_POSTED = 'AskHelpQuestionPosted',
  ASK_HELP_READ_MORE_CLICKED = 'AskHelpReadMoreClicked',
  ASK_HELP_USER_LANDED_ON_AGRI_QUESTION_PAGE = 'AskHelpUserLandedOnAgriQuestionPage',
  ASK_HELP_SEE_POST_CLICKED = 'AskHelpSeePostClicked',
  CROP_GUIDE_USER_LANDED = 'CropGuideUserLanded',
  CROP_GUIDE_ADD_SOWING_DATE_CLICKED = 'CropGuideAddSowingDateClicked',
  CROP_GUIDE_SOWING_DATE_ADDED = 'CropGuideSowingDateAdded',
  CROP_GUIDE_ADD_CROPS_CLICKED = 'CropGuideAddCropsClicked',
  CROP_GUIDE_USER_LANDED_ON_CROP_SELECTION = 'CropGuideUserLandedonCropSelection',
  CROP_GUIDE_CROP_SELECTED = 'CropGuideCropSelected',
  FT_USER_LANDED = 'FTUserLanded',
  FT_POST_LIKED = 'FTPostLiked',
  FT_POST_UNLIKED = 'FTPostUnliked',
  FT_POST_COMMENT_READ_MORE_CLICKED = 'FTPostCommentReadMoreClicked',
  FT_POST_COMMENT_POSTED = 'FTPostCommentPosted',
  FT_POST_WHATSAPP_SHARE_CLICKED = 'FTPostWhatsAppShareClicked',
  FT_THREE_DOTS_CLICKED = 'FTThreeDotsClicked',
  FT_CREATOR_FOLLOWED = 'FTCreatorFollowed',
  FT_CREATOR_CHANNEL_SELECTED = 'FTCreatorChannelSelected',
  FT_TAG_SELECTED = 'FTTagSelected',
  MANDI_PRICE_CROPS_ADDED = 'MandiPriceCropsAdded',
  MANDI_USER_LANDED = 'MandiUserLanded',
  MANDI_PRICE_ADD_CROPS_CLICKED = 'MandiPriceAddCropsClicked',
  MANDI_SEARCH_USER_LANDED = 'MandiSearchUserLanded',
  MANDI_PRICE_LOCATION_CLICKED = 'MandiPriceLocationClicked',
  MANDI_PRICE_LOCATION_SAVED = 'MandiPriceLocationSaved',
  MANDI_PRICE_FEEDBACK = 'MandiPriceFeedback',
  MANDI_PRICE_SOLD_CROP = 'MandiPriceSoldCrop',
  MANDI_PRICE_SUBMIT_RECEIPT_LANDED = 'MandiPriceSubmitReceiptLanded',
  MANDI_PRICE_RECEIPT_SUBMITTED = 'MandiPriceReceiptSubmitted',
  VENDOR_DROPDOWN_CLICKED = 'VendorDropdownClicked',
  VENDOR_CHANGE_BUTTON_CLICKED = 'VendorChangeButtonClicked',
  VENDOR_LOCATION_SELECTED = 'VendorLocationSelected',
  VENDOR_SELECTED = 'VendorSelected',
  FARMER_ORDER_PLACED = 'FarmerOrderPlaced',
  FARMER_BOOKING_PLACED = 'FarmerBookingPlaced',
  USER_CLICKED_SHOP_BY_CATEGORY = 'UserClickedShopbyCategory',
  COMMERCE_USER_CART_VALUE_BELOW_MOV = 'CommerceUserCartValueBelowMOV',
  USER_LANDED_ON_CART = 'UserLandedonCart',
  USER_CLICKED_ON_VIEW_MORE_COUPON = 'UserClickedonViewMoreCoupon',
  USER_CLICKED_ON_REMOVE_COUPON = 'UserClickedonRemoveCoupon',
  USER_APPLIED_COUPON = 'UserAppliedCoupon',
  USER_LANDED_ON_MY_ORDER = 'UserLandedonMyOrder',
  USER_LANDED_ON_MY_ADDRESS = 'UserLandedonMyAddress',
  USER_LANDED_ON_MY_BOOKINGS = 'UserLandedonMyBookings',
  FREE_VIDEO_CALL_USER_LANDED = 'FreeVideoCallUserLanded',
  FREE_VIDEO_CALL_CTA_CLICKED = 'FreeVideoCallCTAClicked',
  USER_CLICKED_ON_SHOP_BY_CROP = 'UserClickedonShopbyCrop',
  USER_CLICKED_ON_SHOP_BY_BRAND = 'UserClickedonShopbyBrand',
  USER_CLICKED_CROP_VIEW_ALL_CTA = 'UserClickedonShopbyCropViewAllCTA',
  USER_CLICKED_BRAND_VIEW_ALL_CTA = 'UserClickedonShopbyBrandViewAllCTA',
  USER_CLICKED_PRODUCT_LISTING_VIEW_ALL = 'UserClickedonProductListingComponentViewAll',
  USER_CLICKED_PRODUCT_LISTING_CARD = 'UserClickedonProductListingComponentProductCard',
  USER_CLICKED_NEED_HELP_CTA = 'UserClickedonPDPNeedHelpCTA',
  USER_CLICKED_NEED_HELP_WHATSAPP = 'UserClickedonPDPNeedHelpWhatsApp',
  USER_CLICKED_NEED_HELP_CALL = 'UserClickedonPDPNeedHelpCall',
  SERVICE_PACKAGE_ADDED = 'Service Package Added',
  PRODUCT_ADDED_TO_WISHLIST = 'ProductAddedToWishlist',
  WISHLIST_PRODUCT_MOVED_TO_CART = 'WishlistProductMovedToCart',
  USER_LANDED_ON_WISHLIST_SCREEN = 'UserLandedOnWishlistScreen',
  WISHLIST_USER_CLICKED_SHOW_SIMILAR_CTA = 'WishlistUserClickedShowSimilarCTA',
  USER_CLICKED_NOTIFY_ME_CTA = 'UserClickedNotifyMeCTA',
  NEARBY_DC_USER_CLICKED_ON_CALL_CTA = 'NearbyDcUserClickedOnCallCTA',
  NEARBY_DC_USER_CLICKED_ON_DIRECTION_CTA = 'NearbyDcUserClickedOnDirectionCTA',
  NEARBY_DC_USER_LANDED_ON_LIST = 'NearbyDCUserLandedOnList',
  USER_LANDED_ON_TECHNICAL_PRODUCT_LISTING_PAGE = 'UserLandedOnTechnicalProductListingPage',
  USER_CLICKED_ON_SEARCH_SUGGESTIONS = 'UserClickedOnSearchSuggestions',
}

export default CustomEventTypes
